module.exports = __webpack_public_path__ + "static/media/brego3590.e92963ef.jpg";